import React from 'react';
import Page from 'components/Page';
import useDataSource from 'hooks/useDataSource';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import EmptyMessage from 'components/EmptyMessage';
import { EDIT_SURVEY } from 'shared/constants/permissions';
import SurveyGroupCard from './SurveyGroupCard';

const extraFields = `
  surveyGroups(statsDateRanges:[{ predefined: LAST_30_DAYS }]) { 
    id 
    title
    type
    surveys {
      id
      responseCounts
      lastResponse
    }
  }
`;

const SurveysDashboard = () => {
  const { dataSource, fetching, hasDataSourcePermission } = useDataSource({ extraFields });
  const surveyGroups = dataSource?.surveyGroups.filter(sg => sg.surveys.some(s => s.responseCounts[0] > 0));
  const noSurveys = dataSource?.surveyGroups.length === 0;
  const canEdit = hasDataSourcePermission(EDIT_SURVEY);

  return (
    <Page loading={fetching}>
      {!surveyGroups?.length ? (
        <EmptyMessage
          title="No active surveys"
          subTitle={noSurveys ? 'Create a survey to get started' : 'No survey has collected any responses in the last 30 days. Select a survey in the sidebar to view old results'}
          extra={canEdit ? [
            <Link key="create-survey" to="list">
              <Button type="primary">Manage surveys</Button>
            </Link>,
          ] : null}
        />
      ) : (
        <>
          <Page.Header title="Active surveys" />
          {surveyGroups?.map(s => (
            <SurveyGroupCard key={s.id} surveyGroup={s} />
          ))}
        </>
      )}
    </Page>
  );
};

export default SurveysDashboard;
